module.exports = __webpack_public_path__ + "static/media/EditCloseIcon.58f10867.svg";